<template>
  <div class="product-buy-detail">
    <div class="product-buy-detail-icon">
      <slot name="icon"></slot>
    </div>
    <div class="product-buy-detail-text">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBuyDetail',
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.product-buy-detail {
  display: flex;
  align-items: flex-start;
}

.product-buy-detail-icon {
  width: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: var(--space-4);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: $mobile-breakpoint) {
    margin-right: var(--space-1);
  }

  @media (min-width: $desktop-breakpoint) {
    margin-right: var(--space-4);
  }
}

.product-buy-detail-text {
  position: relative;

  @media (min-width: $desktop-breakpoint) {
    width: 100%;
  }
}
</style>
